import React from "react";
import moment from "moment";
import {
    RenderKilogramo,
    RenderNumberPercentage,
} from "../../../../Utils/renderField/renderReadField";
import NullableValue from "../../../../Utils/renderField/nullableValue";
import "./styles/Almacenes.css";
const eliminarIcon = require("assets/img/icons/borrar.png");

// Recepciones que quedaron como sobrante en un almacén. onEliminar es opcional:
// sin esa prop no se pinta la columna de acciones, que es como la usa la
// consulta del inventario de otro acopio
export const RecepcionesSobranteTable = ({ recepciones = [], onEliminar }) => {
    const totalColumnas = onEliminar ? 8 : 7;

    const sumar = (campo) =>
        recepciones.reduce(
            (total, recepcion) => total + (recepcion[campo] || 0),
            0,
        );

    return (
        <div className="new-table-wrapper almacenes__table-wrapper">
            <table className="table-striped">
                <thead>
                    <tr>
                        <th>ID RECEPCIÓN</th>
                        <th>FECHA INGRESO</th>
                        <th>KILOS HÚMEDOS</th>
                        <th>DRC LABORATORIO</th>
                        <th>KILOS SECOS LAB</th>
                        <th>DRC LIQUIDACIÓN</th>
                        <th>KILOS SECOS LIQ</th>
                        {onEliminar && <th>ACCIONES</th>}
                    </tr>
                </thead>
                <tbody>
                    {recepciones.length === 0 && (
                        <tr>
                            <td className="text-center" colSpan={totalColumnas}>
                                No se han seleccionado recepciones
                            </td>
                        </tr>
                    )}
                    {recepciones.map((item) => (
                        <tr key={item.id}>
                            <td className="text-center text-nowrap almacenes__ellipsis-cell">
                                {item.display_id}
                            </td>
                            <td className="text-center text-nowrap">
                                {item.fecha_ingreso
                                    ? moment(item.fecha_ingreso).format(
                                          "DD/MM/YYYY HH:mm",
                                      )
                                    : ""}
                            </td>
                            <td className="text-center text-nowrap">
                                <NullableValue value={item.kg_humedos}>
                                    <RenderKilogramo
                                        value={item.kg_humedos}
                                        decimalScale={2}
                                    />
                                </NullableValue>
                            </td>
                            <td className="text-center text-nowrap">
                                <NullableValue value={item.drc_laboratorio}>
                                    <RenderNumberPercentage
                                        value={item.drc_laboratorio}
                                        decimalScale={3}
                                    />
                                </NullableValue>
                            </td>
                            <td className="text-center text-nowrap">
                                <NullableValue value={item.kg_secos_lab}>
                                    <RenderKilogramo
                                        value={item.kg_secos_lab}
                                        decimalScale={3}
                                    />
                                </NullableValue>
                            </td>
                            <td className="text-center text-nowrap">
                                <NullableValue value={item.drc_liquidacion}>
                                    <RenderNumberPercentage
                                        value={item.drc_liquidacion}
                                        decimalScale={3}
                                    />
                                </NullableValue>
                            </td>
                            <td className="text-center text-nowrap">
                                <NullableValue value={item.kg_secos_liq}>
                                    <RenderKilogramo
                                        value={item.kg_secos_liq}
                                        decimalScale={3}
                                    />
                                </NullableValue>
                            </td>
                            {onEliminar && (
                                <td className="text-center text-nowrap">
                                    <div className="table-actions">
                                        <img
                                            src={eliminarIcon}
                                            alt="Eliminar"
                                            className="action_img"
                                            title="Eliminar"
                                            onClick={() => onEliminar(item.id)}
                                        />
                                    </div>
                                </td>
                            )}
                        </tr>
                    ))}
                    {recepciones.length > 0 && (
                        <tr className="modal-ingresos__totales-row">
                            <td className="text-right text-nowrap" colSpan={2}>
                                <strong>TOTALES:</strong>
                            </td>
                            <td className="text-center text-nowrap">
                                <RenderKilogramo
                                    value={sumar("kg_humedos")}
                                    decimalScale={2}
                                />
                            </td>
                            <td></td>
                            <td className="text-center text-nowrap">
                                <RenderKilogramo
                                    value={sumar("kg_secos_lab")}
                                    decimalScale={3}
                                />
                            </td>
                            <td></td>
                            <td className="text-center text-nowrap">
                                <RenderKilogramo
                                    value={sumar("kg_secos_liq")}
                                    decimalScale={3}
                                />
                            </td>
                            {onEliminar && <td></td>}
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
};
